'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RouterContext = require('react-router/lib/RouterContext');

var _RouterContext2 = _interopRequireDefault(_RouterContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyMiddleware = function applyMiddleware() {
  for (var _len = arguments.length, middleware = Array(_len), _key = 0; _key < _len; _key++) {
    middleware[_key] = arguments[_key];
  }

  // middleware looks like: { renderContainer, renderRootContainer }
  var withRootContainer = middleware.filter(function (m) {
    return m.renderRootContainer;
  });
  var withContainer = middleware.filter(function (m) {
    return m.renderContainer;
  });

  var finalCreateElement = function finalCreateElement(Component, props) {
    return _react2.default.createElement(Component, props);
  };

  var createElement = withContainer.reduceRight(function (previous, _ref) {
    var renderContainer = _ref.renderContainer;
    return function (RouteComponent, props) {
      return (0, _react.cloneElement)(renderContainer(RouteComponent, props), { createElement: previous });
    };
  }, finalCreateElement);

  var finalRenderRootContainer = function finalRenderRootContainer(renderProps) {
    return _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, { createElement: createElement }));
  };

  return withRootContainer.reduceRight(function (previous, _ref2) {
    var renderRootContainer = _ref2.renderRootContainer;
    return function (renderProps) {
      return (0, _react.cloneElement)(renderRootContainer(renderProps), { render: previous });
    };
  }, finalRenderRootContainer);
};

exports.default = applyMiddleware;

/*

`applyMiddleware` turns this:

```js
const render = applyMiddleware(
  useAsyncProps({ loadContext: { token } }),
  useNamedRoutes(),
  useRelativeLinks()
)
```

into this:

```js
<Router
  render={(props) => (
    <AsyncProps {...props}
      render={(props) => (
        <NamedRoutes {...props}
          render={(props) => (
            <RelativeLinks {...props}
              createElement={(Component, props) => (
                <AsyncPropsContainer Component={Component} routerProps={props} token={token}
                  createElement={(Component, props) => (
                    <RelativeLinksContainer Component={Component} routerProps={props}/>
                  )}
                />
              )}
            />
          )}
        />
      )}
    />
  )}
/>
```
*/


//////////////////
// WEBPACK FOOTER
// ./~/react-router-apply-middleware/lib/applyMiddleware.js
// module id = 403
// module chunks = 0